// default mixins

import nav from "./nav"
import floatingButtons from "./floatingButtons"
import gdpr from "./gdpr"

export default [
	nav,
	floatingButtons,
	gdpr,
]